const leftButtonPressed = (event: React.MouseEvent) => {
  // Safari has a bug with button / buttons, Firefox has a bug with
  // which. Such is life.
  const mouseEvent = event.nativeEvent;
  if (mouseEvent.buttons !== undefined) {
    return mouseEvent.buttons & 1;
  } else {
    return mouseEvent.which === 1;
  }
};

export default leftButtonPressed;
